import { render, staticRenderFns } from "./PublicDetails.vue?vue&type=template&id=1368ae02&scoped=true&"
import script from "./PublicDetails.vue?vue&type=script&lang=js&"
export * from "./PublicDetails.vue?vue&type=script&lang=js&"
import style0 from "./PublicDetails.vue?vue&type=style&index=0&id=1368ae02&scoped=true&lang=less&"
import style1 from "./PublicDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1368ae02",
  null
  
)

export default component.exports